var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {
        'step': true,
        'is-active': _vm.isActive,
        'is-pulled': _vm.isPulled,
        'is-clickable': _vm.canGoBack
    }, _obj['step-' + _vm.stepNumber] = true, _obj ),on:{"click":_vm.handleClick}},[_c('small',{staticClass:"step-id-small"},[_vm._v(_vm._s(_vm.stepNumber)+".")]),_c('h2',{staticClass:"step-title step-pad"},[_c('span',{staticClass:"step-id-large"},[_vm._v(_vm._s(_vm.stepNumber))]),_c('div',{staticClass:"step-title-text"},[_c('span',{staticClass:"subtitle"},[_vm._t("subtitle")],2),_c('span',{staticClass:"title"},[_vm._t("title")],2)])]),_c('transition',{attrs:{"name":"step-fade"}},[(!_vm.initiallyHidden)?_vm._t("default"):_vm._e()],2)],1)
var _obj;}
var staticRenderFns = []

export { render, staticRenderFns }